function t(r, e) {
  return r ? Array.from(r.querySelectorAll(e)) : [];
}
export {
  t as g
};
